import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material';
import store from '../../store';
import messages from '../../i18n';

import ProductSelection from '../../blocks/pdpV2/ProductSelection';
// Hide MattressAndFrameSelection until Product team  decides to remove/reenable - DCP-3739
// import MattressAndFrameSelection from '../../blocks/pdpV2/MattressAndFrameSelection';
import BedFrameAOV from '../../blocks/pdpV2/BedFrameAOV';
import ComplementaryAOV from '../../blocks/pdpV2/ComplementaryAOV';
import BundlePdpAOV from '../../blocks/pdpV2/BundlePdpAOV/BundlePdpAOV';
import FixedBundlePdpAOV from '../../blocks/pdpV2/FixedBundlePdpAOV';
import AddToCartPDPContainer from '../../blocks/pdpV2/AddToCartPDPContainer';
import { purpleTheme } from '../../themes/default';

const locale = 'en-US';

const queryClient = new QueryClient();

const variantSelectionContainer = document.getElementById('variant-selection');
if (variantSelectionContainer) {
  const variantSelectionRoot = createRoot(variantSelectionContainer);
  variantSelectionRoot.render(
    <QueryClientProvider client={queryClient}>
      <IntlProvider
        messages={messages[locale]}
        locale={locale}
        defaultLocale='en'
      >
        <ThemeProvider theme={purpleTheme()}>
          <Provider store={store}>
            <ProductSelection />
          </Provider>
        </ThemeProvider>
      </IntlProvider>
    </QueryClientProvider>,
  );
}
// Hide MattressAndFrameSelection until Product team  decides to remove/reenable - DCP-3739
// render(
//   <IntlProvider messages={messages[locale]} locale={locale} defaultLocale="en">
//     <Provider store={store}>
//       <MattressAndFrameSelection />
//     </Provider>
//   </IntlProvider>,
//   document.getElementById('matress-and-frame-selection'),
// );

const bedFrameAOVContainer = document.getElementById('bed-frame-aov');
if (bedFrameAOVContainer) {
  const bedFrameAOVRoot = createRoot(bedFrameAOVContainer);
  bedFrameAOVRoot.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale='en'
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <BedFrameAOV />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}

const complementaryAOVContainer = document.getElementById('complementary-aov');
if (complementaryAOVContainer) {
  const complementaryAOVRoot = createRoot(complementaryAOVContainer);
  complementaryAOVRoot.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale='en'
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <ComplementaryAOV />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}

const bundlePdpAOVContainer = document.getElementById('bundle-pdp-aov');
if (bundlePdpAOVContainer) {
  const bundlePdpAOVRoot = createRoot(bundlePdpAOVContainer);
  bundlePdpAOVRoot.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale='en'
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <BundlePdpAOV />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}

const fixedBundlePdpAOVContainer = document.getElementById(
  'fixed-bundle-pdp-aov',
);
if (fixedBundlePdpAOVContainer) {
  const fixedBundlePdpAOVRoot = createRoot(fixedBundlePdpAOVContainer);
  fixedBundlePdpAOVRoot.render(
    <IntlProvider
      messages={messages[locale]}
      locale={locale}
      defaultLocale='en'
    >
      <ThemeProvider theme={purpleTheme()}>
        <Provider store={store}>
          <FixedBundlePdpAOV />
        </Provider>
      </ThemeProvider>
    </IntlProvider>,
  );
}

const addToCartSectionContainer = document.getElementById(
  'add-to-cart-section',
);
if (addToCartSectionContainer) {
  const addToCartSectionRoot = createRoot(addToCartSectionContainer);
  addToCartSectionRoot.render(
    <QueryClientProvider client={queryClient}>
      <IntlProvider
        messages={messages[locale]}
        locale={locale}
        defaultLocale='en'
      >
        <ThemeProvider theme={purpleTheme()}>
          <Provider store={store}>
            <AddToCartPDPContainer />
          </Provider>
        </ThemeProvider>
      </IntlProvider>
    </QueryClientProvider>,
  );
}
